import { useDateLimits } from '../../../../hooks'
import { DatePicker } from '../../../DateTime'

function ProfileInfoWidgetDateField(props) {
  const { maxDate, minDate } = useDateLimits()

  return <DatePicker {...props} maxValue={maxDate} minValue={minDate} />
}

export default ProfileInfoWidgetDateField
